import { Landmark, ShieldAlert, Newspaper, Radar } from 'lucide-react'

export const AML_CHECKLIST_ICONS: Record<string, typeof Landmark> = {
  pep: Landmark,
  sanctions: ShieldAlert,
  'adverse-media': Newspaper,
  'ongoing-monitoring': Radar,
}

export const AML_CHECKLIST_DESCRIPTIONS: Record<string, string> = {
  pep: 'Flags politically exposed persons and their known associates.',
  sanctions: 'Checks against global sanctions lists (OFAC, UN, EU and more).',
  'adverse-media': 'Searches the news and public records for negative coverage.',
  'ongoing-monitoring': 'Keeps re-checking automatically as watchlists change.',
}
